export enum InvoiceType {
  Special = 0,
  General = 1,
  EMPTY = 2, // 未选择
  NOT_NEED = 3, // 不需要
}

export enum InvoiceMedium {
  Electronic = 0,
  Paper = 1,
}

export enum InvoiceTitleType {
  Individual = 0,
  Enterprise = 1,
}
export interface IMallCourseSkuInfoItem {
  item_name: string
  item_pic?: any
  item_amount: number
}

export interface IMallCourseSkuInfo {
  sku_id: string
  sku_name: string
  sku_pic: string
  pay_amount: number
  items: IMallCourseSkuInfoItem[]
}

export interface IMallCourseSpecialInfo {
  consult_link_url: string
  introduce_url?: any
  pre_purchase_button_name: string
  sku_info: IMallCourseSkuInfo[]
}

export interface IMallCoursePostSpecialInfo {
  sku_id: string
  post_purchase_button_name: string
  post_purchase_button_link_url: string
  post_purchase_pic: string
  post_consult_link_url: string
}

export interface IMallCourseItem {
  id: string
  title: string
  cover_path?: any
  introduce_path?: any
  address: string
  type: MallCourseType
  switch: boolean
  start_time: string
  end_time: string
  sale_start_time?: any
  sale_end_time?: any
  special_info: IMallCourseSpecialInfo
}

export interface IMallCourseList {
  count: number
  items: IMallCourseItem[]
}

export interface IMallCourseDetail {
  id: string
  title: string
  cover_path?: any
  introduce_path?: any
  address: string
  type: string
  switch: boolean
  start_time: string
  end_time: string
  sale_start_time?: any
  sale_end_time?: any
  special_info: IMallCourseSpecialInfo
  skus: IMallCourseSkuInfo[]
  remittance_notice: string
}

export enum MallCourseType {
  OnlineCourse = 'online_course',
  OfflineCourse = 'offline_course',
  Hardware = 'hardware',
}

export interface IMallCourseBillInfo {
  bill_type: InvoiceType
  bill_medium: InvoiceMedium
  bill_header: string
  bill_header_body: InvoiceTitleType
  bill_content: string
  bill_address: string
  bill_receiver_name: string
  bill_receiver_phone: string
  bill_receiver_email: string
  bill_tax_id: string
  bank_of_deposit: string
  bank_of_deposit_account: string
  note: string
}

export interface IMallCourseAddressInfo {
  name: string
  phone_code: string
  phone: string
  province: string
  city: string
  region: string
  detail_address: string
}

export interface IMallCourseCreateOrderForm {
  mall_course_id: string
  sku_id: string
  count: number
  bill_info: IMallCourseBillInfo
  address_info: IMallCourseAddressInfo
  _remittance_notice?: string
  _course_address?: string
}

export interface IMallCourseInfo {
  order_id: string
  state: number
  order_name: string
  leave_time: number
  target_time: number
  pay_amount: number
}

export interface IMallCourseOrderInfo {
  mall_course_order_id: string
  out_order_id: string
  out_sku_id: string
  sku_name: string
  sku_special_info: IMallCoursePostSpecialInfo
  mall_course: IMallCourseItem
}

export interface IMallCourseCallbackSkuItem {
  product_name: string
  sku_stock: string
  product_id: string
  product_type: string
  sku_id: string
  sku_name: string
  sku_attribute_type: string
  sku_attribute_code: string
  sku_attribute_value: string
  real_amount: string
  sku_pic: string
  delivery_state: string
}

export interface IMallCourseCallbackSku {
  product_name: string
  sku_stock: string
  product_id: string
  product_type: string
  sku_id: string
  sku_name: string
  sku_attribute_type: string
  sku_attribute_code: string
  sku_attribute_value: string
  real_amount: string
  sku_pic: string
  delivery_state: string
  items: IMallCourseCallbackSkuItem[]
}

export interface IMallCourseOrderCallback {
  user_id: string
  order_id: string
  state: string
  phone: string
  pay_type: string
  skus: IMallCourseCallbackSku[]
}

export enum PaymentMethod {
  B2B = 'b2b',
  Online = 'online',
}

export interface IMallCourseRegion {
  province: string
  city: string
  region: string
}

export enum IMallCoursePayStatus {
  NoPayment = 0,
  Cancel = 1,
  Payment,
}
export interface IMallCoursePayStatusRes {
  order_id: string
  pay_status: IMallCoursePayStatus
}

export interface IMallCourseSkuSpecialInfo {
  sku_id: string
  post_purchase_button_name: string
  post_purchase_button_link_url?: string
  post_purchase_pic?: string
}

export interface IMallCourseOrderItem {
  mall_course_order_id: string
  out_order_id: string
  out_sku_id: string
  sku_name: string
  sku_special_info: IMallCourseSkuSpecialInfo
  mall_course: IMallCourseDetail
  sku_pic: string
}

export interface IMallCourseOrderList {
  count: number
  items: IMallCourseOrderItem[]
}
